import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { WA_LINK, TOKENS } from '../tokens';

const links = [
  { label: 'Details',     href: '#the-details' },
  { label: 'Location',    href: '#the-location' },
  { label: 'Opportunity', href: '#the-opportunity' },
  { label: 'Pricing',     href: '#the-price' },
  { label: 'Contact',     href: '#contact' },
];

function smoothScroll(href) {
  const id = href.replace('#', '');
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        zIndex: 800,
        height: 52,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 48px',
        background: scrolled ? 'rgba(0,0,0,0.82)' : 'rgba(0,0,0,0.6)',
        backdropFilter: 'saturate(180%) blur(20px)',
        WebkitBackdropFilter: 'saturate(180%) blur(20px)',
        borderBottom: '1px solid rgba(255,255,255,0.07)',
        transition: 'background 0.4s ease',
      }}
    >
      {/* Brand */}
      <div style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '0.9rem', fontWeight: 300,
        letterSpacing: '0.08em',
        color: TOKENS.GOLD, opacity: 0.88,
      }}>
        Jhandewalan · Central Delhi
      </div>

      {/* Desktop links */}
      <ul style={{
        display: 'flex', gap: 28, listStyle: 'none',
        '@media(max-width:768px)': { display: 'none' },
      }} className="nav-desktop-links">
        {links.map(l => (
          <li key={l.label}>
            <a
              href={l.href}
              onClick={e => { e.preventDefault(); smoothScroll(l.href); }}
              style={{
                fontSize: '0.72rem', fontWeight: 400, letterSpacing: '0.04em',
                color: 'rgba(255,255,255,0.75)', textDecoration: 'none',
                transition: 'color 0.2s', cursor: 'none',
              }}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.75)'}
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>

      {/* WhatsApp CTA */}
      <a
        href={WA_LINK()}
        target="_blank"
        rel="noreferrer"
        style={{
          padding: '7px 18px',
          background: TOKENS.GOLD,
          color: TOKENS.BLACK,
          fontFamily: "'Outfit', sans-serif",
          fontSize: '0.72rem', fontWeight: 500, letterSpacing: '0.04em',
          borderRadius: 980, textDecoration: 'none',
          transition: 'background 0.2s, transform 0.2s',
          cursor: 'none',
          whiteSpace: 'nowrap',
        }}
        onMouseEnter={e => { e.target.style.background = TOKENS.GOLD_LIGHT; e.target.style.transform = 'scale(1.03)'; }}
        onMouseLeave={e => { e.target.style.background = TOKENS.GOLD; e.target.style.transform = 'scale(1)'; }}
      >
        WhatsApp Us
      </a>

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop-links { display: none !important; }
        }
      `}</style>
    </motion.nav>
  );
}
